export default __webpack_public_path__ + "static/media/welcome-red.ddfa7f63.svg";